import React, { FC, useEffect, useState } from 'react';

import { DOTS_REAR_GAP, DOTS_VISIBLE_COUNT } from './constants';
import { Dot, DotWrapper, Slider } from './styles';
import { CarouselDotsIndicatorsProps } from './types';

export const CarouselDotsIndicators: FC<CarouselDotsIndicatorsProps> = ({
    slidesCount,
    activeIndex,
    ...boxStyles
}) => {
    const [dotsOffsetCount, setDotsOffsetCount] = useState<number>(0);

    const switchDots = (pos: number, max: number) => {
        let offset = 0;

        if (pos === max) {
            offset = pos + 1 - DOTS_VISIBLE_COUNT;
        } else if (pos > Math.floor(max / 2) && pos < max) {
            offset = pos + 1 - DOTS_VISIBLE_COUNT + DOTS_REAR_GAP;
        } else if (pos > 0) {
            offset = pos - DOTS_REAR_GAP;
        }

        setDotsOffsetCount(offset);
    };

    useEffect(() => {
        if (slidesCount > DOTS_VISIBLE_COUNT) {
            switchDots(activeIndex, slidesCount - 1);
        }
    }, [activeIndex, slidesCount]);

    if (slidesCount < 2) {
        return null;
    }

    return (
        <Slider {...boxStyles}>
            <DotWrapper dotsOffset={dotsOffsetCount}>
                {Array(slidesCount)
                    .fill(0)
                    .map((_, index) => (
                        <Dot isActive={index === activeIndex} />
                    ))}
            </DotWrapper>
        </Slider>
    );
};
